module.exports = __webpack_public_path__ + "static/media/CV_GlisseJorge.44b088e0.pdf";